'use strict'

var schema = require('property-information/svg')
var caseSensitive = require('./svg-case-sensitive-tag-names.json')
var factory = require('./factory')

var svg = factory(schema, 'g', caseSensitive)
svg.displayName = 'svg'

module.exports = svg
